// @flow

/**
 * Strip trailing slash
 */
export default (path: string) =>
    path.endsWith("/") ? path.slice(0, -1) : path;
